import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import InfoPage from '../../InfoPage';

// The format display names are brand/product names and stay as-is; the
// page title reuses the localized "{{format}} at StarView Cinema" template.
const FORMAT_NAMES = {
  imax: 'IMAX',
  'dolby-cinema': 'Dolby Cinema',
  '3d': '3D',
  'apple-vision': 'Apple Vision',
  vr: 'VR',
};

export default function FormatPage() {
  const { t } = useTranslation();
  const { formatId } = useParams();
  const name = FORMAT_NAMES[formatId];
  if (!name) return <Navigate to="/our-brands" replace />;
  const body = t(`formatPages.${formatId}.body`, { returnObjects: true }) || [];

  return (
    <InfoPage
      eyebrow={t('info.premiumFormats')}
      title={t('footer.atStarView', { format: name })}
      subtitle={t(`formatPages.${formatId}.subtitle`)}
    >
      {body.map((paragraph, i) => <p key={i}>{paragraph}</p>)}
    </InfoPage>
  );
}
